import StaxProcessor from './StaxProcessor';
import ForteProcessor from './ForteProcessor';

/**
 * Factory function to create appropriate payment processor
 * @param {string} merchant - Merchant type ('stax' or 'forte')
 * @returns {StaxProcessor|ForteProcessor} - Payment processor instance
 */
export const createPaymentProcessor = (merchant) => {
  const merchantLower = (merchant || '').toLowerCase();
  
  switch (merchantLower) {
    case 'stax':
      return new StaxProcessor();
    case 'forte':
      return new ForteProcessor();
    default:
      throw new Error(`Unsupported merchant type: ${merchant}`);
  }
};

export { StaxProcessor, ForteProcessor };

export default {
  createPaymentProcessor,
  StaxProcessor,
  ForteProcessor,
};
